import * as React from 'react';

import styled from 'styled-components';

import { testId } from '../test-utils/constants';

export function LoadingSpinner() {
	return (
		<SpinnerWrapper data-testid={testId('Loading_Spinner_Wrapper')}>
			<LoadingIconCircle data-testid={testId('Loading_Spinner')} />
		</SpinnerWrapper>
	);
}

const SpinnerWrapper = styled.div`
	grid-row: 1/-1;
	grid-column: 1/-1;

	margin: auto;
`;

interface CircleDimensionsProps {
	$loaderSize: number;
}

const ThinCircle = styled.div<CircleDimensionsProps>`
	position: absolute;
	height: ${props => props.$loaderSize}px;
	width: ${props => props.$loaderSize}px;
`;

const MovingHalfCircle = styled.div<CircleDimensionsProps>`
	position: relative;
	height: ${props => props.$loaderSize}px;
	width: ${props => props.$loaderSize}px;
	animation-name: circle_rotation;
	animation-iteration-count: infinite;
	animation-duration: 5s;
	@keyframes circle_rotation {
		100% {
			transform: rotate(360deg);
		}
	}
`;

const LoadingIconCircle = () => {
	const loaderSize = 150;

	return (
		<>
			<ThinCircle $loaderSize={loaderSize}>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 199">
					<circle fill="none" stroke="#FFFFFF" strokeWidth="2" strokeOpacity="0.2" cx="99" cy="100" r="99" />
				</svg>
			</ThinCircle>

			<MovingHalfCircle $loaderSize={loaderSize}>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 199" fill="none">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						fill="#ffffff"
						d="M180.1,45C162.5,19,132.7,2,99,2V0c34.9,0,65.6,17.9,83.5,45H180.1z"
						stroke="#ffffff"
						strokeWidth="1"
					/>
				</svg>
			</MovingHalfCircle>
		</>
	);
};
